import * as Scrivito from "scrivito";

function isNumber(str) {
  const num = Number(str);
  return Number.isFinite(num);
}

Scrivito.provideComponent(
  "SpaceWidget",
  Scrivito.connect(({ widget }) => {
    const customSize = widget.get("customSize");
    const cssSize =
      customSize && isNumber(customSize) ? `${customSize}rem` : customSize;

    const fixedSize = widget.get("fixedSize");
    const size = widget.get("size") || 5;
    const actualSize = cssSize || fixedSize || `${size}rem`;

    return <div style={{ height: `${actualSize}` }} />;
  })
);
